/* Lazy product storytelling video, including Shopify section editor reloads. */
if (!customElements.get('rapid-product-video')) {
  customElements.define('rapid-product-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video[data-video-src]');
      if (!this.video || this.observer) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.video.controls = true;
      this.onMotion = () => { if (this.motion.matches) this.video.pause(); };
      this.motion.addEventListener('change', this.onMotion);
      this.onVisibility = () => { if (document.hidden) this.video.pause(); };
      document.addEventListener('visibilitychange', this.onVisibility);
      const loadVideo = () => {
        if (!this.isConnected || this.video.hasAttribute('src')) return;
        this.video.src = this.video.dataset.videoSrc;
        this.video.load();
        if (this.video.dataset.autoplay === 'true' && !this.motion.matches && !document.hidden) {
          const playback = this.video.play();
          if (playback) playback.catch(() => { this.video.controls = true; });
        }
      };
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some(entry => entry.isIntersecting)) {
            loadVideo();
            this.observer.disconnect();
          }
        }, { rootMargin: '300px 0px' });
        this.observer.observe(this.video);
      } else {
        loadVideo();
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.observer = null;
      if (this.video) this.video.pause();
      if (this.motion && this.onMotion) this.motion.removeEventListener('change', this.onMotion);
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }
  });
}

/* Keep below-fold embed downloads outside the initial product loading path.
 * The original player is inserted shortly before it reaches the viewport. */
if (!customElements.get('rapid-product-embed')) {
  customElements.define('rapid-product-embed', class extends HTMLElement {
    connectedCallback() {
      if (this.observer || this.loaded) return;
      const template = this.querySelector('template');
      if (!template || !template.content.querySelector('iframe')) return;
      const load = () => {
        if (!this.isConnected || this.loaded) return;
        this.loaded = true;
        this.appendChild(template.content.cloneNode(true));
        template.remove();
        const fallback = this.querySelector('[data-rapid-embed-fallback]');
        if (fallback) fallback.remove();
        if (this.observer) this.observer.disconnect();
        this.observer = null;
      };
      if ('IntersectionObserver' in window && !(window.Shopify && window.Shopify.designMode)) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) load();
        }, { rootMargin: '600px 0px' });
        this.observer.observe(this);
      } else {
        load();
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.observer = null;
    }
  });
}
